// extracted by mini-css-extract-plugin
export default {"imageCard":"ImageCard_imageCard__goDg7","image":"ImageCard_image__XeXig"};